import React from 'react';
import styled from 'styled-components';
import { IconPlanPro, IconPlanPremium, } from '@commoncomponents/frontend-components/dist/components/Icons/Icons';
const Wrapper = styled.div `
  display: inline-flex;
  flex-direction: row;
  float: right;
  line-height: 22px;
  padding: 2px 6px 2px 0px;
  height: 16px;
  border-radius: 4px;
  background-color: ${(props) => props.text === 'PREMIUM' ? '#E8F4FB' : '#c2cbd7'};
  max-width: 75px;
  align-items: flex-end;
  margin: 0;

  svg {
    max-height: 12px;
  }
`;
const Text = styled.span `
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
  line-height: 10px;
  color: ${(props) => (props.text === 'PREMIUM' ? '#1C92DD' : '#0d1e2e')}
  align-self: center;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:focus {
    outline: 0;
  }

`;
const PlanChip = ({ text }) => {
    return (React.createElement(Wrapper, { text: text },
        text === 'PRO' ? (React.createElement(IconPlanPro, { color: "#0d1e2e" })) : (React.createElement(IconPlanPremium, { color: "#1C92DD" })),
        React.createElement(Text, { className: "tooltip-icon", text: text }, text)));
};
export default PlanChip;
